// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__Hgoa3Cog","tab":"Tabs_tab__7V2oDWXY","active":"Tabs_active__tu13jzff"};